import { c as _c } from "react/compiler-runtime";
import type { LiveItem } from '@module/apis/client-side/live/type';
import SettingConfig from '@module/config/setting';
import { aspCond } from '@module/helpers/conditions/condition';
import getSpecialDayLottieFileName from '@module/helpers/lottie/getSpecialDayLottieFileName';
import { scrollIntoPlayerArea } from '@module/helpers/play/scrollIntoPlayerArea';
import useBroadcastDescriptionResizeHandler from '@module/helpers/useBroadcastDescriptionResizeHandler';
import { cn } from '@module/lib/utils';
import { useASPInfo } from '@module/queries/asp/query';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import useIsDarkModeStore from '@module/stores/useIsDarkModeStore';
import { formatTimeElapsedSince } from '@module/utils/date/convertDateFormat';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';
import useIsMounted from '@module/utils/useIsMounted';
import BaseLottie from '@pc/components/lottie/BaseLottie';
import { TooltipBox } from '@pc/components/tooltip/TooltipBox';
import useGoPlay from '@pc/hooks/play/useGoPlay';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { useCallback, useState } from 'react';
interface Props {
  item: LiveItem;
}
function BroadcastUserItem(t0) {
  const $ = _c(115);
  const {
    item
  } = t0;
  const {
    title,
    user,
    isPw,
    fanLevel,
    userId: streamerId,
    userNick,
    bjAnni,
    isAdult,
    listDeco: t1,
    type,
    startTime,
    listUp,
    userLimit,
    globalYN
  } = item;
  const listDeco = t1 === undefined ? "0" : t1;
  const thumbUrl = item.thumbUrl ?? item.ivsThumbnail;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      onOverThreshold: () => setTooltipOpen(true),
      onUnderThreshold: () => setTooltipOpen(false)
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    observerRef
  } = useBroadcastDescriptionResizeHandler(t2);
  const pathname = usePathname();
  const isPlayPage = pathname.includes("/play");
  const isLivePage = pathname.includes("/live");
  const isListUpIcon = isPlayPage || isLivePage;
  const isSpecialDay = !!bjAnni;
  const router = useRouter();
  const rawParams = useParams();
  const userId = rawParams?.userId ? decodeURIComponent(rawParams.userId) : rawParams?.userId;
  const isMounted = useIsMounted();
  const {
    isChatPanelOpen
  } = useChatPanelStore();
  const {
    isDark
  } = useIsDarkModeStore();
  const {
    goPlay
  } = useGoPlay();
  let t3;
  if ($[1] !== isDark) {
    t3 = url => {
      if (url.includes("_adult")) {
        return `${SettingConfig.S3_BUCKET_URL}/img/bg/silver_adult${isDark ? "_dark" : ""}.png`;
      }
      return url;
    };
    $[1] = isDark;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const getThumbUrl = t3;
  const isFull = user >= userLimit;
  const titleLengthCheck = _temp;
  const {
    data: aspInfo
  } = useASPInfo();
  const isAspInfo = !!aspInfo;
  const t4 = cn("w-1/4 xxxl:w-[16.5%] pr-[20px] pb-[28px] lg:w-1/5 xl:w-1/6", {
    "w-1/3 lg:w-1/4 xl:w-1/5": isPlayPage && isChatPanelOpen && !isAspInfo
  });
  const t5 = "break-all";
  const t6 = "group relative block overflow-hidden bg-center bg-cover bg-no-repeat hover:cursor-pointer";
  let t7;
  if ($[3] !== goPlay || $[4] !== item || $[5] !== streamerId || $[6] !== userId) {
    t7 = e => {
      e.stopPropagation();
      if (streamerId === userId) {
        scrollIntoPlayerArea();
      } else {
        goPlay(item);
      }
    };
    $[3] = goPlay;
    $[4] = item;
    $[5] = streamerId;
    $[6] = userId;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("inset-0 top-0 left-0 aspect-video h-max w-full object-cover transition-transform duration-300 group-hover:scale-110");
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== getThumbUrl || $[10] !== thumbUrl) {
    t9 = getThumbUrl(thumbUrl);
    $[9] = getThumbUrl;
    $[10] = thumbUrl;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== item.userImg) {
    t10 = e_0 => {
      if (e_0.currentTarget.src === item.userImg) {
        return;
      }
      e_0.currentTarget.src = item.userImg;
    };
    $[12] = item.userImg;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9 || $[16] !== title) {
    t11 = <div className="relative overflow-hidden rounded-[8px] "><img width="100%" height="100%" className={t8} src={t9} onError={t10} alt={title} /></div>;
    $[14] = t10;
    $[15] = t9;
    $[16] = title;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== isSpecialDay) {
    t12 = isSpecialDay && <div className="absolute inset-0 top-0 left-0 aspect-video h-max w-full rounded-[8px] bg-black bg-opacity-50" />;
    $[18] = isSpecialDay;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== bjAnni || $[21] !== isSpecialDay) {
    t13 = isSpecialDay && <BaseLottie src={`${SettingConfig.S3_BUCKET_URL}/json/lottie/anniversary/${getSpecialDayLottieFileName(bjAnni)}`} className={cn("-translate-x-1/2 absolute top-0 left-1/2 z-[1] h-[calc(100%-58px)] transition-opacity ")} />;
    $[20] = bjAnni;
    $[21] = isSpecialDay;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const T0 = TooltipBox;
  const t14 = title || "";
  let t15;
  if ($[23] !== t14 || $[24] !== titleLengthCheck) {
    t15 = titleLengthCheck(t14);
    $[23] = t14;
    $[24] = titleLengthCheck;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = !tooltipOpen;
  const t17 = "start";
  const t18 = `bg-listDeco-${listDeco}`;
  let t19;
  if ($[26] !== t18) {
    t19 = cn("video_card_wrapper flex h-[80px] w-full bg-[length:auto_100%] bg-center bg-repeat-x pt-[10px]", t18);
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  const t20 = "min-w-0 flex-1";
  const t21 = "mt-0 w-full align-top";
  const t22 = cn("relative line-clamp-2 text-colorFg19", {
    "pr-[18px]": isListUpIcon
  });
  let t23;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span />;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] !== isAdult) {
    t24 = isAdult && <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_19.png`} width={20} alt="19" className="mr-1 mb-1 inline align-middle" />;
    $[29] = isAdult;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== isPw) {
    t25 = isPw && <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_lock.png`} width={15} alt="lock" className="mr-1 mb-1 inline align-middle" />;
    $[31] = isPw;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] !== item.browser) {
    t26 = item.browser === "android" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_mobile.png`} width={16} alt="mobile" className="mr-1 mb-1 inline align-middle" />;
    $[33] = item.browser;
    $[34] = t26;
  } else {
    t26 = $[34];
  }
  let t27;
  if ($[35] !== type) {
    t27 = type === "charge" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_money.png`} width={16} alt="charge" className="mr-1 mb-1 inline align-middle" />;
    $[35] = type;
    $[36] = t27;
  } else {
    t27 = $[36];
  }
  let t28;
  if ($[37] !== fanLevel || $[38] !== type) {
    t28 = type === "fan" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/grade/grade_${fanLevel}.svg`} width={20} alt="fan" className="mr-1 mb-1 inline align-middle" />;
    $[37] = fanLevel;
    $[38] = type;
    $[39] = t28;
  } else {
    t28 = $[39];
  }
  let t29;
  if ($[40] !== t24 || $[41] !== t25 || $[42] !== t26 || $[43] !== t27 || $[44] !== t28) {
    t29 = <span>{t24}{t25}{t26}{t27}{t28}</span>;
    $[40] = t24;
    $[41] = t25;
    $[42] = t26;
    $[43] = t27;
    $[44] = t28;
    $[45] = t29;
  } else {
    t29 = $[45];
  }
  const t30 = title || "";
  let t31;
  if ($[46] !== t30 || $[47] !== titleLengthCheck) {
    t31 = titleLengthCheck(t30);
    $[46] = t30;
    $[47] = titleLengthCheck;
    $[48] = t31;
  } else {
    t31 = $[48];
  }
  let t32;
  if ($[49] !== t31) {
    t32 = <span className="text-colorFg01">{t31}</span>;
    $[49] = t31;
    $[50] = t32;
  } else {
    t32 = $[50];
  }
  let t33;
  if ($[51] !== isListUpIcon || $[52] !== listUp) {
    t33 = isListUpIcon && listUp && <img className="absolute top-[4px] right-0" src={`${SettingConfig.S3_BUCKET_URL}/img/store/item/listUp/${listUp}.png`} width={18} height={18} alt="listup" />;
    $[51] = isListUpIcon;
    $[52] = listUp;
    $[53] = t33;
  } else {
    t33 = $[53];
  }
  let t34;
  if ($[54] !== observerRef || $[55] !== t22 || $[56] !== t29 || $[57] !== t32 || $[58] !== t33) {
    t34 = <p ref={observerRef} className={t22}>{t23}{t29}{t32}{t33}</p>;
    $[54] = observerRef;
    $[55] = t22;
    $[56] = t29;
    $[57] = t32;
    $[58] = t33;
    $[59] = t34;
  } else {
    t34 = $[59];
  }
  let t35;
  if ($[60] !== globalYN) {
    t35 = !SettingConfig.isProd && globalYN === "Y" && <img className="mr-1 inline w-[60px] align-middle" src={`${SettingConfig.S3_BUCKET_URL}/img/vipDeco/ico_global_tag.svg`} alt="global" />;
    $[60] = globalYN;
    $[61] = t35;
  } else {
    t35 = $[61];
  }
  let t36;
  if ($[62] !== item.newBjYN) {
    t36 = item.newBjYN === "Y" && <img className="mr-1 inline w-[14px] align-middle" src={`${SettingConfig.S3_BUCKET_URL}/img/icon/new_round.png`} alt="viewer" />;
    $[62] = item.newBjYN;
    $[63] = t36;
  } else {
    t36 = $[63];
  }
  let t37;
  if ($[64] !== router || $[65] !== streamerId) {
    t37 = e_1 => {
      e_1.stopPropagation();
      if (aspCond.if("iframe-asp")) {
        return;
      }
      router.push(`/channel/${streamerId}/notice/`);
    };
    $[64] = router;
    $[65] = streamerId;
    $[66] = t37;
  } else {
    t37 = $[66];
  }
  let t38;
  if ($[67] !== t37 || $[68] !== userNick) {
    t38 = <button onClick={t37} className="inline align-middle text-[13px] hover:underline">{userNick}</button>;
    $[67] = t37;
    $[68] = userNick;
    $[69] = t38;
  } else {
    t38 = $[69];
  }
  let t39;
  let t40;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <div className="mx-[2px] inline items-center justify-center align-middle text-sm">·</div>;
    t40 = <img className="mr-1 inline h-[11px] align-middle" src={`${SettingConfig.S3_BUCKET_URL}/img/icon/viewer_black_line.png`} alt="viewer" />;
    $[70] = t39;
    $[71] = t40;
  } else {
    t39 = $[70];
    t40 = $[71];
  }
  let t41;
  if ($[72] !== isFull || $[73] !== user) {
    t41 = isFull ? "FULL" : formatNumberWithComma(user);
    $[72] = isFull;
    $[73] = user;
    $[74] = t41;
  } else {
    t41 = $[74];
  }
  let t42;
  if ($[75] !== t41) {
    t42 = <span className="inline align-middle">{t41}</span>;
    $[75] = t41;
    $[76] = t42;
  } else {
    t42 = $[76];
  }
  let t43;
  let t44;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div className="mx-[2px] inline items-center justify-center align-middle text-sm">·</div>;
    t44 = <img className="mr-1 inline h-[11px] align-middle" src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_list_look.png`} alt="look" />;
    $[77] = t43;
    $[78] = t44;
  } else {
    t43 = $[77];
    t44 = $[78];
  }
  let t45;
  if ($[79] !== item.playCnt) {
    t45 = formatNumberWithComma(item.playCnt);
    $[79] = item.playCnt;
    $[80] = t45;
  } else {
    t45 = $[80];
  }
  let t46;
  if ($[81] !== t45) {
    t46 = <span className="inline align-middle">{t45}</span>;
    $[81] = t45;
    $[82] = t46;
  } else {
    t46 = $[82];
  }
  let t47;
  let t48;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <div className="mx-[5px] inline items-center justify-center align-middle text-sm">·</div>;
    t48 = <img className="mr-1 inline h-[11px] align-middle" src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_list_time.png`} alt="time" />;
    $[83] = t47;
    $[84] = t48;
  } else {
    t47 = $[83];
    t48 = $[84];
  }
  let t49;
  if ($[85] !== isMounted || $[86] !== startTime) {
    t49 = isMounted && <span className="align-middle">{formatTimeElapsedSince(startTime)}</span>;
    $[85] = isMounted;
    $[86] = startTime;
    $[87] = t49;
  } else {
    t49 = $[87];
  }
  let t50;
  if ($[88] !== t35 || $[89] !== t36 || $[90] !== t38 || $[91] !== t42 || $[92] !== t46 || $[93] !== t49) {
    t50 = <div className="block w-full overflow-hidden overflow-ellipsis whitespace-nowrap align-top text-[#777] text-[13px]">{t35}{t36}{t38}{t39}{t40}{t42}{t43}{t44}{t46}{t47}{t48}{t49}</div>;
    $[88] = t35;
    $[89] = t36;
    $[90] = t38;
    $[91] = t42;
    $[92] = t46;
    $[93] = t49;
    $[94] = t50;
  } else {
    t50 = $[94];
  }
  let t51;
  if ($[95] !== t34 || $[96] !== t50) {
    t51 = <div className={t20}><div className={t21}>{t34}{t50}</div></div>;
    $[95] = t34;
    $[96] = t50;
    $[97] = t51;
  } else {
    t51 = $[97];
  }
  let t52;
  if ($[98] !== t19 || $[99] !== t51) {
    t52 = <div className={t19}>{t51}</div>;
    $[98] = t19;
    $[99] = t51;
    $[100] = t52;
  } else {
    t52 = $[100];
  }
  let t53;
  if ($[101] !== T0 || $[102] !== t15 || $[103] !== t16 || $[104] !== t52) {
    t53 = <T0 content={t15} disabled={t16} align={t17}>{t52}</T0>;
    $[101] = T0;
    $[102] = t15;
    $[103] = t16;
    $[104] = t52;
    $[105] = t53;
  } else {
    t53 = $[105];
  }
  let t54;
  if ($[106] !== t11 || $[107] !== t12 || $[108] !== t13 || $[109] !== t53 || $[110] !== t7) {
    t54 = <div className={t5}><div className={t6} onClick={t7}>{t11}{t12}{t13}{t53}</div></div>;
    $[106] = t11;
    $[107] = t12;
    $[108] = t13;
    $[109] = t53;
    $[110] = t7;
    $[111] = t54;
  } else {
    t54 = $[111];
  }
  let t55;
  if ($[112] !== t4 || $[113] !== t54) {
    t55 = <li className={t4}>{t54}</li>;
    $[112] = t4;
    $[113] = t54;
    $[114] = t55;
  } else {
    t55 = $[114];
  }
  return t55;
}
function _temp(title_0) {
  let replaceTitle = title_0 || "";
  if (replaceTitle.length > 38) {
    replaceTitle.substring(0, 38);
    replaceTitle = `${replaceTitle.substring(0, 38)}\n${replaceTitle.substring(38)}`;
  }
  return replaceTitle;
}
export default BroadcastUserItem;